import React from "react";
import LegalPage from "@/components/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" testid="privacy-page">
      <p>
        Colleen Prosser Art respects your privacy. This policy explains what personal
        information we collect, how it is used, and the role of our payment processor, Stripe.
      </p>

      <h2>What We Collect</h2>
      <p>When you place an order we collect:</p>
      <ul>
        <li>Your name and email address.</li>
        <li>Your delivery address (street, suburb, state, postcode, country).</li>
        <li>Order details (which artwork you purchased and the amount paid).</li>
      </ul>
      <p>
        We do <strong>not</strong> collect or store your credit-card or bank-account details on
        our servers. Card information is entered directly into a Stripe-hosted checkout page.
      </p>

      <h2>Why We Collect It</h2>
      <ul>
        <li>To process your order and arrange delivery.</li>
        <li>To send you a confirmation and shipping notification.</li>
        <li>To meet our tax, accounting and Australian Consumer Law obligations.</li>
      </ul>

      <h2>Payments &amp; Stripe</h2>
      <p>
        Payments on this site are processed by <strong>Stripe Payments Australia Pty Ltd</strong>{" "}
        (a PCI-DSS Level 1 certified payment provider). When you check out, you are redirected
        to a secure Stripe checkout page. Stripe collects and processes your payment details on
        its own servers in accordance with its own{" "}
        <a
          href="https://stripe.com/au/privacy"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>{" "}
        and the{" "}
        <a
          href="https://stripe.com/au/legal"
          target="_blank"
          rel="noreferrer"
        >
          Stripe Services Agreement
        </a>
        . Stripe may share with us limited information such as the last four digits of your
        card, the brand, expiry month/year, and the transaction status &mdash; never the full
        card number.
      </p>

      <h2>Cookies &amp; Local Storage</h2>
      <p>
        We use your browser's local storage to remember the contents of your shopping cart and
        whether you have seen our Acknowledgement of Country. We do not use third-party
        advertising cookies. Stripe sets its own cookies during checkout to prevent fraud.
      </p>

      <h2>Who We Share Your Data With</h2>
      <ul>
        <li><strong>Stripe</strong> &mdash; for processing payments.</li>
        <li>
          <strong>Our delivery courier</strong> &mdash; to ship the artwork to your address.
        </li>
        <li>
          <strong>Government or law-enforcement authorities</strong>, where we are legally
          required to do so.
        </li>
      </ul>
      <p>We do not sell or rent your personal information to anyone, ever.</p>

      <h2>How We Store It</h2>
      <p>
        Your order details are stored in a secure database operated for us by our hosting
        provider. We retain them only for as long as is necessary to fulfil the order and to
        meet our legal record-keeping obligations (typically 7 years for tax records under
        Australian law).
      </p>

      <h2>Your Rights</h2>
      <p>
        Under the Australian Privacy Act 1988 (Cth) you can request a copy of the personal
        information we hold about you, ask us to correct it, or ask us to delete it (subject to
        our legal obligations). Email{" "}
        <a href="mailto:colleen.prosser@outlook.com">colleen.prosser@outlook.com</a>{" "}
        and we will respond within 30 days.
      </p>

      <h2>Complaints</h2>
      <p>
        If you are not satisfied with how we have handled your personal information, you may
        lodge a complaint with the Office of the Australian Information Commissioner (OAIC) at{" "}
        <a href="https://www.oaic.gov.au" target="_blank" rel="noreferrer">
          oaic.gov.au
        </a>
        .
      </p>

      <p className="text-xs uppercase tracking-widest text-[#5B5653] pt-8 border-t border-[#E3DDD7]">
        Last updated: {new Date().toLocaleDateString("en-AU", { month: "long", year: "numeric" })}
      </p>
    </LegalPage>
  );
}
